<template>
    <c-body>
        <div id="history-box" slot="section">
            <!-- 顶部header模块 -->
            <header slot="header" class="c-body-header">
                <div class="header-row history-header">
                    <div class="header-row-left ">

                        <div class="row">

                            <Dropdown trigger="custom" :visible="visibleSearch" @on-clickoutside="visibleSearch=false">
                                <Input v-model="tableParams.keyword" placeholder="请输入ID,或名称" class="header-search" icon="android-search" @on-change="onGetSearch" @on-keydown.enter="onGetSearch" @on-click="onGetSearch" />
                                <DropdownMenu slot="list">
                                    <div style="width: 3rem; max-height: 4rem;overflow-y:auto;">
                                        <div style="width: 20px; margin: 0 auto;padding: 0.2rem 0;" v-if="searchLoading">
                                            <!-- <Spin></Spin> -->
                                        </div>
                                        <div v-else-if="searchList.length == 0" style="text-align: center; margin: 0 auto;padding: 0.2rem 0;">
                                            <div>请输入正确的ID或名称</div>
                                        </div>
                                        <div v-else @click="onGetSeachSelect(item)" v-for="(item, key) in searchList" class="search-item" :key="key">
                                            <span>{{item.id}}</span>
                                            <span>{{item.name}}</span>
                                            <span>{{typeLevel(item.level)}}</span>
                                        </div>
                                    </div>
                                </DropdownMenu>
                            </Dropdown>
                            <Input style="margin-left:10px" v-model="tableParams.operatorName" placeholder="请输入操作人" class="header-search" icon="android-search"  @on-keydown.enter="getList(true)" @on-click="getList(true)" />


                        </div>
                        <div class="row" style="margin-top: 0.2rem;">
                            <!-- 状态筛选 -->

                            <!-- 自定义列 -->
                            <quota :indicatorListDefault="indicatorListDefault" :indicatorListQuo="indicatorList" @onIndicatorList="onIndicatorList" :tableParams.sync="tableParams"></quota>

                        </div>
                    </div>
                    <div class="header-row-right history-row-right">

                        <div class="row ">
                            <!-- 预设日期按钮 -->
                            <c-date-picker :startDay.sync="tableParams.startDate" :endDay.sync="tableParams.endDate" @change="getList"></c-date-picker>
                        </div>

                    </div>
                </div>
            </header>
            <!-- 顶部header模块 -->
            <!-- 主体section模块 -->
            <section slot="section" class="c-body-section">
                <!-- 表格 -->
                <table class="c-body-table history-table-wrap">
                    <thead class="table-thead">
                        <tr class="table-tr">

                            <td class="table-td-primary">
                                <span>ID</span>
                            </td>
                            <td class="table-td-primary">
                                <span>名称</span>
                            </td>
                            <td class="table-td-primary">
                                <span>广告主</span>
                            </td>
                            <td class="table-td-primary">
                                <span>操作人（账号）</span>
                            </td>
                            <td class="table-td-primary">
                                <span>操作层级</span>
                            </td>
                            <td class="table-td-primary">
                                <span>操作项</span>
                            </td>
                            <td class="table-td-primary">
                                <span>操作内容</span>
                            </td>
                            <td class="table-td-primary">
                                <span>操作前</span>
                            </td>
                            <td class="table-td-primary">
                                <span>操作后</span>
                            </td>
                            <td class="table-td-primary">
                                <span>操作时间</span>
                            </td>
                            <td class="table-td-primary">
                                <span>操作类型</span>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="table-tr" v-for="(item, index) in originData" :key="index">
                            <td class="table-td-primary">
                                {{item.operateId}}
                            </td>
                            <td class="table-td-primary">
                                {{item.name?item.name:'/'}}
                            </td>
                            <td class="table-td-primary">
                                {{item.publisherName?item.publisherName:'/'}}
                            </td>
                            <td class="table-td-primary">
                                {{item.operatorName?item.operatorName:'/'}}
                            </td>
                            <td class="table-td-primary">
                                {{typeLevel(item.level)?typeLevel(item.level):'/'}}
                            </td>
                            <td class="table-td-primary">
                                {{tyName(item.operatorCode)?tyName(item.operatorCode):'/'}}
                            </td>
                            <td class="table-td-primary" :class="{act: ( item.operatorCode=='CampaignRule'||item.operatorCode==8||item.operatorCode=='CampaignTargetCountries'||item.operatorCode=='CampaignTargetLanguage')}">
                                <span @click="onShowCountryDetail(item)">
                                    {{item.operatorCode=='CampaignTargetCountries'||item.operatorCode=='CampaignTargetLanguage' ? nameChange(item.details): item.operatorCode=='CampaignRule'? nameRule(item.details): item.details? item.details: '/'}}
                                </span>
                            </td>
                            <td class="table-td-primary" :class="{act: (item.operatorCode =='CampaignTargetTime' || item.operatorCode=='CampaignRule'||item.operatorCode==8)}">
                                <span @click="onShowCountryDetail(item, 't')">{{item.operatorCode =='CampaignTargetTime' ? '查看详情' : item.fromDesc?item.fromDesc:'/'}}</span>
                            </td>
                            <td class="table-td-primary" :class="{act: (item.operatorCode =='CampaignTargetTime' || item.operatorCode=='CampaignRule'||item.operatorCode==8)}">
                                <span @click="onShowCountryDetail(item, 'd')">{{item.operatorCode =='CampaignTargetTime' ? '查看详情' : item.toDesc?item.toDesc:'/'}}</span>
                            </td>
                            <td class="table-td-primary">
                                {{item.createtime?item.createtime:'/'}}
                            </td>
                            <td class="table-td-primary">
                                {{item.type == 'auto' ? '自动': '手动'}}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <!-- 表格 -->
            </section>
            <!-- 主体section模块 -->
            <!-- 时段 -->
            <Modal v-model="show.time" width="650" class="c-modal" @on-ok="submitTime">
                <p slot="header" class="modal-header">时段</p>
                <div class="modal-detail">
                    <tiem-zone @timezone="onTargetTimeChange" :showHistory="true" :timezone="targetTime" :disabled="true"></tiem-zone>
                </div>
                <div slot="footer">

                </div>
            </Modal>
            <!-- 时段 -->
            <!-- 操作记录  2 -->
            <Modal v-model="show.control" width="700" class="c-model-control history-hbox" :styles="{top: '30px', position: 'absolute'}" @on-visible-change="onShowCountryDetail">

                <div class="modal-detail">
                    <div class="detail-row">
                        <div class="row-title">操作内容</div>
                        <div class="row-title">操作前</div>
                        <div class="row-title">操作后</div>
                    </div>
                    <div class="detail-row">
                        <div class="row-item">
                            <div class="i-title">白名单</div>
                            <div class="i-dec">增加：{{CampaignData.name.white.add}}</div>
                            <div class="i-dec">去除： {{CampaignData.name.white.remove}}</div>
                        </div>
                        <div class="row-item">
                            <span class="i-title">白名单:</span> {{CampaignData.before.white}}
                        </div>
                        <div class="row-item">
                            <span class="i-title">白名单:</span> {{CampaignData.after.white}}
                        </div>
                    </div>
                    <div class="detail-row last">
                        <div class="row-item">
                            <div class="i-title">黑名单</div>
                            <div class="i-dec">增加：{{CampaignData.name.dark.add}}</div>
                            <div class="i-dec">去除： {{CampaignData.name.dark.remove}}</div>
                        </div>
                        <div class="row-item">
                            <span class="i-title">黑名单:</span> {{CampaignData.before.dark}}
                        </div>
                        <div class="row-item">
                            <span class="i-title">黑名单:</span> {{CampaignData.after.dark}}
                        </div>
                    </div>
                </div>
                <div slot="footer">

                </div>
            </Modal>
            <!-- 操作记录 -->
            <!-- 操作记录  6 -->
            <Modal v-model="show.set" width="700" class="c-model-control history-hbox" :styles="{top: '30px', position: 'absolute'}" @on-visible-change="onShowCountryDetail">

                <div class="modal-detail">
                    <div style="width: 20px; margin: 0 auto;padding: 0.2rem 0;" v-if="ruleShow">
                        <!-- <Spin></Spin> -->
                    </div>
                    <table class="c-table-model" v-else>
                        <thead>
                            <tr>
                                <th class="bold" v-if="!setTableShowType"></th>
                                <th>ID</th>
                                <th>名称</th>
                                <th>维度</th>
                                <th>时间范围</th>
                                <th>条件</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-if="!setTableShowType || setTableShowType == 'd'" v-for="(item,index) in addruleList" :key="index">
                                <td class="bold" v-if="!setTableShowType">新增</td>
                                <td>{{item.id}}</td>
                                <td>{{item.name?item.name:'/'}}</td>
                                <td>{{dimensionList[item.type]?dimensionList[item.type]:'/'}}</td>
                                <td>{{item.time+timeList[item.timeType]?item.time+timeList[item.timeType]:'/'}}</td>
                                <td>
                                    <span v-for="(condition,i) in item.conditionText" :key="i">{{condition}}</span>
                                </td>
                            </tr>
                            <tr v-if="(!setTableShowType || setTableShowType == 'd') && addruleList.length == 0 " >
                                <td class="bold" v-if="!setTableShowType">新增</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr v-if="!setTableShowType || setTableShowType == 't'" v-for="(item,index) in removeruleList" :key="`c-${index}`">
                                <td class="bold" v-if="!setTableShowType">移除</td>
                                <td>{{item.id}}</td>
                                <td>{{item.name?item.name:'/'}}</td>
                                <td>{{dimensionList[item.type]?dimensionList[item.type]:'/'}}</td>
                                <td>{{item.time+timeList[item.timeType]?item.time+timeList[item.timeType]:'/'}}</td>
                                <td>
                                    <span v-for="(condition,i) in item.conditionText" :key="i">{{condition}}</span>
                                </td>
                            </tr>
                             <tr v-if="(!setTableShowType || setTableShowType == 't') && removeruleList.length == 0 " >
                                <td class="bold" v-if="!setTableShowType">移除</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>

                        </tbody>
                    </table>

                </div>
                <div slot="footer"></div>
            </Modal>
            <!-- 操作记录 -->

            <footer slot="footer" class="c-body-footer">
                <!-- 分页器 -->
                <c-page :table-params.sync="tableParams" :page-bean.sync="pageBean" class="foot-row" @on-change="getList(false)" @on-page-size-change="getList(true)" />
            </footer>
        </div>
    </c-body>
</template>
<script>
import common from '@/utils/common';
import mixins from '@/mixins/index.js';
import tiemZone from '@/components/commons/Drag.vue';
import cBody from '@/components/commons/cBody.vue';
import cDatePicker from '@/components/commons/cDatePicker.vue';
import quota from '@/components/commons/quota-history.vue';
import cPage from '@/components/commons/cPage.vue';
import cTable from '@/components/commons/manageTable.vue';
import cBid from '@/components/commons/cBid.vue';

export default {
    name: 'managementSeries',
    mixins: [mixins],
    components: {
        tiemZone,
        cTable,
        cBid,
        cBody,
        cDatePicker,
        quota,
        cPage,
    },
    props: {
        tagSeries: {
            type: Number,
        },
    },
    data() {
        return {
            targetTime: '', //批量修改时段
            date: [],
            visibleSearch: false,
            searchLoading: false,
            ruleShow: false, //规则加载
            //显示控制器
            show: {
                bidPrice: false,
                set: false,
                time: false,
                control: false,
            },
            // show.set 弹窗是否显示新增，移除 类型
            setTableShowType: '',
            // 搜素列表
            searchList: [],
            //推广列表数据
            originData: [],
            dimensionList: { 1: '推广', 2: '广告', 3: '国家', 4: '广告位' },
            timeList: { week: '周', day: '天', hour: '小时' },
            //条件
            quotaList: [{ label: 'CTR', value: 1 }, { label: 'CVR', value: 2 }, { label: '展示量', value: 3 }, { label: 'eCPM', value: 4 }],
            //大于小于
            mathList: { 1: '>', 2: '<' },
            //单位列表
            unitList: { 1: '%', 2: '%', 3: '千次', 4: '$' },
            //分页对象
            pageBean: {
                currentPage: 1,
                pageSize: 10,
                startNum: 0,
                totalNum: 0,
                totalPage: 1,
            },
            //获取推广列表的参数
            tableParams: {
                keyword: '',
                level: '',
                type: '',
                page: 1,
                pageSize: 10,
                startDate: this.mixinGetDate('today'),
                endDate: this.mixinGetDate('today'),
                operateId: '',
                operatorCode: '',
                operatorName:'',
            },
            statusText: ['审核中', '全部通过', '全部拒绝'],
            statusColor: ['#ef9051', '#23c52f', '#fd5f65'],
            //汇总
            summary: {},

            //指标列表
            indicatorList: {},
            indicatorListDefault: {},
            CampaignData: {
                name: {
                    dark: {
                        add: '',
                        remove: '',
                    },
                    white: {
                        add: '',
                        remove: '',
                    },
                },
                before: {
                    dark: '',
                    white: '',
                },
                after: {
                    dark: '',
                    white: '',
                },
            },
            CampaignRule: [{}],
            addruleList: [],
            removeruleList: [],
            // 规则参数模板
            editParamsTemplate: {
                name: '',
                type: 1,
                conditionArr: [],
                conditionObject: {
                    1: {
                        indicator: 1,
                        operator: 1,
                        indicatorValue: '',
                    },
                    2: {
                        indicator: 2,
                        operator: 1,
                        indicatorValue: '',
                    },
                    3: {
                        indicator: 3,
                        operator: 1,
                        indicatorValue: '',
                    },
                    4: {
                        indicator: 4,
                        operator: 1,
                        indicatorValue: '',
                    },
                },
                timeType: 'day',
                time: '',
                status: 1,
            },
        };
    },
    watch: {
        // 'tableParams.keyword'(value) {
        //     if (!value) {
        //         this.tableParams.type = '';
        //         this.tableParams.level = '';
        //         this.tableParams.operateId = '';
        //         this.tableParams.operatorCode = '';
        //     }
        // },
        'tableParams.type'() {
            this.indicatorList = this.deepClone(this.indicatorListDefault);
        },
    },
    computed: {
        // 指标栏是否默认
        isDefaultIndicator() {
            return !this.indicatorArr.some(item => item.selected != item.isDefault) || this.indicatorArr.every(item => !item.selected);
        },
    },
    created() {
        this.getHistoryItem();
    },
    methods: {
        nameRule(value) {
            let name = '规则';
            if (value) {
                let rn = value.split(';')[0] ? value.split(';')[0].split(',') : '';
                let an = value.split(';')[1] ? value.split(';')[1].split(',') : '';
                if (rn) {
                    name += `移除${rn.length}项,`;
                }
                if (an) {
                    name += `新增${an.length}项,`;
                }
            } else {
                name = '/';
            }
            return name;
        },
        nameChange(value) {
            if (value) {
                let test = '';

                let name = value.split(';');
                if (name[0] && name[0].split('、').length > 0) test += `白名单新增：${name[0].split('、').length}项,`;
                if (name[1] && name[1].split('、').length > 0) test += `白名单去除：${name[1].split('、').length}项,`;
                if (name[2] && name[2].split('、').length > 0) test += `黑名单新增：${name[2].split('、').length}项,`;
                if (name[3] && name[3].split('、').length > 0) test += `黑名单去除：${name[3].split('、').length}项,`;
                return test;
            } else {
                return '';
            }
        },
        //tableParams.type类型转化值
        typeKey(value) {
            if (value == 'series') {
                return '0';
            } else if (value == 'campaign') {
                return '1';
            } else if (value == 'offer') {
                return '2';
            } else {
                return '';
            }
        },

        /**
         * @description 获取指标列表更新
         */
        onIndicatorList(data) {
            this.indicatorList = this.deepClone(data);
            let type = this.typeKey(this.tableParams.level);
            if (type) {
                let value = [];
                this.indicatorList[type].forEach(item => {
                    if (item.selected) {
                        value.push(item.code);
                    }
                });
                this.tableParams.operatorCode = value.join(',');
            } else {
                if (this.indicatorList[0]) {
                    let value = '';
                    for (let i in this.indicatorList) {
                        let arr = [];
                        this.indicatorList[i].forEach(item => {
                            if (item.selected) {
                                arr.push(item.code);
                            }
                        });
                        value += arr.join(',');
                    }
                    this.tableParams.operatorCode = value;
                }
            }
            this.getList(true);
        },
        // 搜索类型名称转换
        typeLevel(value) {
            if (value == 'series') {
                return '广告系列';
            } else if (value == 'campaign') {
                return '广告组';
            } else if (value == 'offer') {
                return '广告';
            } else {
                return '';
            }
        },
        async getHistoryItem() {
            let res = await this.$axios.get(this.$port.log.listOperators);

            if (res && res.status == 200) {
                let obj = res.data;
                for (let i in obj) {
                    obj[i].map(item => {
                        item.isDefault = true;
                        item.selected = true;
                    });
                }
                this.indicatorList = obj;
                this.indicatorListDefault = obj;
            }
            this.getList(true);
        },
        /**
         * @description 获取搜素数据
         * @param
         */
        async onGetSearch() {
            if (this.tableParams.keyword != '') {
                this.visibleSearch = true;
                this.searchLoading = true;
                let res = await this.$axios.get(this.$port.log.searchList, {
                    params: { keyword: this.tableParams.keyword },
                    cancelLoading: true,
                });
                if (res && res.status == 200) {
                    this.searchList = res.data;
                    this.searchLoading = false;
                } else {
                    this.visibleSearch = false;
                    this.searchLoading = false;
                }
            } else {
                this.tableParams.type = '';
                this.tableParams.level = '';
                this.tableParams.operateId = '';
                this.tableParams.keyword = '';
                // this.tableParams.operatorCode = '';
                this.getList(true);
            }
        },
        async onGetSeachSelect(data) {
            this.tableParams.keyword = `${data.id}`;
            this.tableParams.type = data.level;
            this.tableParams.operateId = data.id;
            // this.tableParams.operateId = '';
            this.visibleSearch = false;
            this.getList(true);
        },
        /**
         * @description 显示详情列表 - 国家定向
         * @param data
         */
        onShowCountryDetail(data, type) {
            if (data.operatorCode == 'CampaignTargetLanguage' || data.operatorCode == 'CampaignTargetCountries') {
                if (!type) {
                    this.show.control = true;
                    let CampaignData = {
                        name: {
                            dark: {
                                add: data.details.split(';')[2],
                                remove: data.details.split(';')[3],
                            },
                            white: {
                                add: data.details.split(';')[0],
                                remove: data.details.split(';')[1],
                            },
                        },
                        before: {
                            dark: data.fromDetails.split(';')[1] ? data.fromDetails.split(';')[1] : '',
                            white: data.fromDetails.split(';')[0],
                        },
                        after: {
                            dark: data.toDetails.split(';')[1] ? data.toDetails.split(';')[1] : '',
                            white: data.toDetails.split(';')[0],
                        },
                    };
                    console.log('CampaignData', CampaignData, data);
                    this.CampaignData = CampaignData;
                }
            } else if (data.operatorCode == 'CampaignRule') {
                this.show.set = true;
                this.ruleShow = true;

                this.ruleShow = false;
                if (type) {
                    this.setTableShowType = type;
                    if (type == 't') {
                        this.getRuleList(data.fromDetails);
                    } else {
                        this.getRuleList(data.toDetails, 'add');
                    }
                } else {
                    this.setTableShowType = type;
                    this.getRuleList(data.details.split(';')[0] ? data.details.split(';')[0] : '0');
                    this.getRuleList(data.details.split(';')[1] ? data.details.split(';')[1] : '0', 'add');
                }
                this.CampaignRule = [];
            } else if (data.operatorCode == 'CampaignTargetTime') {
                // 时段

                if (type == 't') {
                    this.targetTime = data.fromDetails;
                } else if (type == 'd') {
                    this.targetTime = data.toDetails;
                } else {
                    this.targetTime = data.fromDetails;
                }
                if (type) {
                    this.show.time = true;
                }
            }
        },
        /**
         * @description 获取操作记录列表
         * @param isInit:boolean 是否初始化页数
         */
        async getList(isInit, loaded) {
            if (isInit) this.tableParams.page = 1;
            // this.tableParams.level = this.tableParams.type;
            this.tableParams.type = '';
            this.tableParams.level = '';
            //获取表格数据 -获取汇总数据
            let parms = this.deepClone(this.tableParams);

            // parms.operatorName = ''
            // parms.startDate = '2019-03-25'
            // parms.endDate = '2022-09-25'
            // parms.operatorCode = ''

            // return

            const getList = this.$axios.get(this.$port.log.offlineReport, {
                params: parms,
            });
            let resList = await getList;
            if (resList && resList.status == 200) {
                this.pageBean = resList.data.pageBean;
                this.originData = resList.data.list;
            }
        },
        /**
         * @description 设置国家数组
         * @param countries:string 国家字符串
         * @param length:number 最大长度
         * @return string[] 国家数组
         */
        setCountryTag(countries, length) {
            if (!countries) countries = 'ALL';
            let countryTag = countries.split(',');
            if (countryTag.length > length) countryTag = [...countryTag.filter((a, i) => i < length - 1), '....'];
            return countryTag;
        },

        /*
         * @description 限制只能输入数字
         * @param event:obj 事件对象
         */
        onInputNumber(event) {
            this.mixinRegNum(event, -1);
        },
        /**
         * @description 修改日期
         * @param event:obj 事件对象
         */
        onDateChange(date) {
            this.date = [...date];
        },
        /*
         * @description 修改时段字符串
         * @param timeStr:string 时段字符串
         */
        onTargetTimeChange(timeStr) {
            this.targetTime = timeStr;
        },
        /**
         * @desc 获取自动优化规则
         */
        async getRuleList(value, type) {
            this.removeruleList = [];
            this.addruleList = [];
            const res = await this.$axios.get(this.$port.rule.getRuleList, {
                params: { status: 0, page: 1, pageSize: 10000, ids: value },
                cancelLoading: true,
            });
            const rules = res.data.rules || [];
            rules.forEach(item => {
                if (item.week != 0) {
                    item.time = item.week;
                    item.timeType = 'week';
                }
                if (item.day != 0) {
                    item.time = item.day;
                    item.timeType = 'day';
                }
                if (item.hour != 0) {
                    item.time = item.hour;
                    item.timeType = 'hour';
                }
                item.conditionText = [];
                item.conditionArr = [];
                item.conditionObject = Object.assign({}, this.editParamsTemplate.conditionObject);
                item.conditions.forEach(con => {
                    item.conditionArr.push(con.indicator);
                    item.conditionObject[con.indicator] = con;
                    item.conditionText.push(
                        `${this.quotaList[con.indicator - 1].label + this.mathList[con.operator] + con.indicatorValue + this.unitList[con.indicator]}`
                    );
                });
            });
            if (!type) {
                this.removeruleList = rules;
            } else {
                this.addruleList = rules;
            }
        },
        /**
         * @description 提交修改日期
         */
        async submitDate() {
            let arr = [];
            this.selectedList.forEach((item, index) =>
                arr.push({
                    id: item.id,
                    startDay: this.date[0],
                    endDay: this.date[1],
                })
            );
            const params = arr;
            const res = await this.$axios.post(this.$port.seriesTable.batchUpdate, params);
            this.afterSubmit(res);
        },

        /**
         * @description 提交修改时段
         */
        async submitTime() {
            const params = {
                campaigns: this.selectedList.map((item, index) => ({
                    id: item.id,
                    targetTime: this.show.targetTime ? this.targetTime : '',
                })),
            };
            const res = await this.$axios.post(this.$port.manager.batchUpdateCampaign, params);
            this.afterSubmit(res);
        },
        /**
         * @description 批量操作后回调
         * @param res:obj 请求回调对象
         */
        afterSubmit(res) {
            if (res.status == 200) {
                this.$Message.success({ content: '修改成功', duration: 1.5 });
                this.getList(false);
            } else {
                this.$Message.error({ content: '修改失败', duration: 1.5 });
            }
        },
        tyName(code) {
            if (code == 'SeriesBundle') {
                return '包名';
            } else if (code == 'SeriesCampaignType') {
                return '行业';
            } else if (code == 'SeriesClickUrl') {
                return '落地页链接';
            } else if (code == 'SeriesTotalBudget') {
                return '总预算';
            } else if (code == 'SeriesDailyBudget') {
                return '日预算';
            } else if (code == 'SeriesFrequency') {
                return '频次';
            } else if (code == 'SeriesDay') {
                return '日期';
            } else if (code == 'SeriesStatus') {
                return '广告系列状态';
            } else if (code == 'SeriesImpCallbackUrl') {
                return '第三方展示监控链接';
            } else if (code == 'SeriesNewCampaign') {
                return '广告组新建';
            } else if (code == 'CampaignTargetCountries') {
                return '国家定向';
            } else if (code == 'CampaignTargetLanguage') {
                return '语言定向';
            } else if (code == 'CampaignTargetIP') {
                return 'IP定向';
            } else if (code == 'CampaignTargetOs') {
                return '操作系统';
            } else if (code == 'CampaignTargetDeviceType') {
                return '设备类型';
            } else if (code == 'CampaignTargetConnectionType') {
                return '网络类型';
            } else if (code == 'CampaignTargetDeviceGroups') {
                return '人群定向';
            } else if (code == 'CampaignTargetSource') {
                return '渠道';
            } else if (code == 'CampaignTargetSourceChannel') {
                return '媒体分类';
            } else if (code == 'CampaignTargetTime') {
                return '时段';
            } else if (code == 'CampaignDailyBudget') {
                return '日预算';
            } else if (code == 'CampaignSpeed') {
                return '速度';
            } else if (code == 'CampaignBidPrice') {
                return '出价';
            } else if (code == 'CampaignStatus') {
                return '广告组状态';
            } else if (code == 'CampaignRule') {
                return '自动优化设置';
            } else if (code == 'CampaignNewOffer') {
                return '广告新建';
            } else if (code == 'OfferStatus') {
                return '广告状态';
            } else if (code == 'SeriesName') {
                return '名称';
            } else if (code == 'CampaignTargetBundleType') {
                return '媒体类型';
            }else if (code == 'OfferSizeType') {
                return '广告尺码类型';
            }else if (code == 'OfferTitle') {
                return '广告原生标题';
            }else if (code == 'OfferDescription') {
                return '广告描述';
            }else if (code == 'OfferImgUrl') {
                return '广告大图URL';
            }else if (code == 'OfferBgUrl') {
                return '广告动图背景';
            }else if (code == 'OfferIconUrl') {
                return '广告ICON URL';
            }else if (code == 'OfferCreativeType') {
                return '广告类型';
            }else if (code == 'OfferName') {
                return '广告素材名称';
            }else if (code == 'OfferVerifyStatus') {
                return '广告审核状态';
            }else if (code == 'OfferVerifyRemark') {
                return '广告审核意见';
            }else if (code == 'OfferVideoTime') {
                return '广告素材视频时长';
            }else if (code == 'OfferVideoUrl') {
                return '广告素材视频链接';
            }else if (code == 'OfferButtonText') {
                return '广告素材按钮文案';
            }else if (code == 'OfferH5Url') {
                return '广告素材h5链接';
            }else if (code == 'OfferH5Type') {
                return '广告素材h5类型';
            }else if (code == 'OfferCountries') {
                return '广告国家定向设置';
            }else if (code == 'OfferAnimation') {
                return '广告素材动效';
            }else if (code == 'OfferSpeed') {
                return '广告素材切换速度';
            }else if (code == 'OfferTransition') {
                return '广告素材切换动画';
            }else if (code == 'CampaginName') {
                return '广告组名称';
            }else if (code == 'OfferName') {
                return '广告名称';
            }else if (code == 'CampaignChannelType') {
                return '子渠道类型';
            }else if (code == 'CampaignChannels') {
                return '子渠道包名';
            }
        },
    },
};
</script>
<style lang="scss">
@import 'src/style/frequently.scss';
@import 'src/style/cModal.scss';
.c-model-control.history-hbox {
    .modal-detail {
        margin-top: 20px;
        max-height: 4.5rem;
        overflow-y: auto;
        .detail-row {
            width: 100%;
            font-size: 13px;
            display: flex;
            &.last {
                margin-top: 0.1rem;
            }
            .row-item {
                flex: 0 0 33%;
                padding-right: 0.15rem;
            }
            .row-title {
                font-weight: bold;
                margin-bottom: 0.15rem;
                font-size: 14px;
                text-align: center;
                flex: 0 0 33%;
            }
            box-sizing: border-box;
            padding-right: 0.1rem;
            .i-title {
                margin-bottom: 0.1rem;
                font-weight: bold;
            }
            .i-dec {
                margin-left: 0.24rem;
            }
        }
    }
    .c-table-model {
        font-size: 13px;
        width: 100%;
        border: none;
        border-collapse: collapse;
        th,
        td {
            text-align: center;
            min-width: 0.8rem;
            border: none;
            padding: 0.05rem 0.05rem;
            &.bold {
                width: 0.45rem;
                min-width: 0.45rem;
                font-weight: bold;
            }
        }
    }
}
#history-box {
    .history-header {
        align-items: flex-end !important;
        .search-item {
            overflow: hidden;
            padding: 0 0.15rem;
            display: flex;
            cursor: pointer;
            flex: 1 1 auto;
            line-height: 0.3rem;
            span {
                flex: 1;
                &:nth-child(2) {
                    flex: 0 0 1rem;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                &:nth-child(3) {
                    text-align: right;
                }
            }
            &:hover {
                background: #f2f2f2;
            }
        }
    }
    .history-table-wrap {
        .act {
            color: #169bd5;
            cursor: pointer;
        }
    }
    .history-row-right {
        align-items: flex-end !important;
    }
    .header-search {
        width: 3rem !important;
        margin-right: 0 !important;
    }
    .c-body-section .c-body-table .table-tr {
        .table-td-primary {
            min-width: 0.4rem;
            max-width: 1rem;
            line-height: 1;
            white-space: normal !important;
            word-break: break-all;
        }
        .table-td-primary:nth-of-type(1) {
            padding-right: 0;
            padding-left: 0.2rem;
        }
        //展示删除创意按钮
    }
    .header-row-left {
        display: flex;
        flex-direction: column;
        align-items: left;
        .row {
            width: 100%;
            display: flex;
        }
    }

    .row-margin {
        margin-bottom: 0.15rem;
    }
    .header-row-right {
        display: flex;
        flex-direction: column;
        .row {
            justify-content: flex-end;
            width: 100%;
            display: flex;
        }
        .refresh-btn {
            margin-right: 0 !important;
        }
    }
    .down-btn {
        background-color: #fff;
        margin-right: 0.06rem;
    }

    .show-delete-offer {
        width: 100%;
        background: #eff3f6;
        line-height: 0.4rem;
        font-size: 0.14rem;
        text-align: center;
        color: #237ec5;
        cursor: pointer;
    }
    .shai-box {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        position: relative;
        .shai-text {
            height: 100%;
            display: flex;
            align-items: center;
            width: 2.2rem;
            min-width: 200px;
            position: absolute;
            flex: 1;
            .close-btn {
                cursor: pointer;
                position: absolute;
                top: 0.12rem;
                right: 1.2rem;
            }
        }
    }
    .edit-box {
        justify-content: flex-end;
        display: flex;
        width: 2.5rem;
        position: relative;
        align-items: center;
        .edit {
            width: 2.5rem;
            height: 100%;
            display: flex;
            align-items: center;
            position: absolute;
            flex: 1;
            .close-btn {
                cursor: pointer;
                position: absolute;
                top: 0.12rem;
                right: 1.2rem;
            }
        }
    }
    .tag-list {
        flex: 0 0 0.8rem;
        margin-left: 0.05rem;
    }
    // 创意推广名称
    .create-name-box {
        position: relative;
        display: flex;
        align-items: center;
        height: 100%;
        width: 100%;
        .ivu-poptip-rel {
            vertical-align: middle;
        }
        .create-name-box-left {
            display: flex;
            margin: auto 0;
            flex: 0 0 0.42rem;
            align-items: center;
            justify-content: center;
            width: 0.42rem;
            height: 0.42rem;
            margin-right: 0.18rem;
            border-radius: 0.04rem;
            background-color: #fff;
        }
        .create-name-box-right {
            display: flex;
            flex-direction: column;
            height: 0.42rem;
            flex: 1 1 1.6rem;
            .create-name {
                display: flex;
                line-height: 0.22rem;
                font-size: 0.14rem;
                color: #333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 1.6rem;
                .create-status {
                    margin-left: 0.1rem;
                    flex: 0 0 auto;
                    font-size: 0.1rem;
                }
            }
            .create-attr {
                display: flex;
                justify-content: space-between;
                line-height: 0.2rem;
                .create-attr-left {
                    display: flex;
                    align-items: center;
                    line-height: 0.2rem;
                    .create-size {
                        display: block;
                        margin-right: 0.05rem;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/record/history.vue